export const b2cBoardKeys = {
  all: ["b2c-board"] as const,
  stages: () => [...b2cBoardKeys.all, "stages"] as const,
  workstreams: () => [...b2cBoardKeys.all, "workstreams"] as const,
  gates: () => [...b2cBoardKeys.all, "gates"] as const,
  iterations: () => [...b2cBoardKeys.all, "iterations"] as const,
  branches: () => [...b2cBoardKeys.all, "branches"] as const,
  tasks: () => [...b2cBoardKeys.all, "tasks"] as const,
  // taskActivity nests under activity, so invalidating activity() refreshes both feeds.
  activity: () => [...b2cBoardKeys.all, "activity"] as const,
  taskActivity: (id: string) => [...b2cBoardKeys.all, "activity", id] as const,
};
